import type { MultiPolygon, Polygon } from 'geojson'
import { useDataPoisByType } from './data/useDataPoisByType'

export function useBoundary(
	insee?: string,
	{ level, disable }: { level?: number; disable?: boolean } = {},
): {
	geojson?: Polygon | MultiPolygon
	status: 'loaded' | 'loading' | 'pending' | 'failed'
	error?: string
} {
	const {
		pois: boundaries,
		status,
		error,
	} = useDataPoisByType('boundaries', { level, disable: disable || !insee })

	const geojson = boundaries.find(
		boundary => boundary.properties!['ref:INSEE'] === insee,
	)?.geojson as Polygon | MultiPolygon

	return {
		geojson,
		status,
		error,
	}
}
